var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "165px",
    height: "165px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3.95 3.95",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:#C0C3C7;stroke-width:0.02;stroke-miterlimit:22.9256}\r\n    .str1 {stroke:#ADB0B3;stroke-width:0.05;stroke-miterlimit:22.9256;stroke-dasharray:0.050000 0.050000}\r\n    .str2 {stroke:#ADB0B3;stroke-width:0.1;stroke-miterlimit:22.9256}\r\n    .fil0 {fill:none}\r\n    .fil4 {fill:#9EA1A4}\r\n    .fil8 {fill:#ADB0B3}\r\n    .fil2 {fill:#C0C3C7}\r\n    .fil5 {fill:#E3E6EA}\r\n    .fil1 {fill:#EAECEC}\r\n    .fil7 {fill:#F5F7F7}\r\n    .fil9 {fill:white}\r\n    .fil6 {fill:#C0C3C7;fill-rule:nonzero}\r\n    .fil3 {fill:#CCCCCC;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 3.95,
    height: 3.95
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1682116925856"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 1.22,
    y: 0.58,
    width: 2.1,
    height: 2.26,
    rx: 0.11,
    ry: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1.33 0.55l1.88 0c0.06,0 0.11,0.05 0.11,0.11l0 0.2 -2.1 0 0 -0.2c0,-0.06 0.05,-0.11 0.11,-0.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3 str0",
    points: "2.42,1.59 2.54,1.59 2.54,1.97 2.42,1.97 2.42,2 2.57,2 2.57,1.56 2.56,1.56 2.42,1.56 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1.6,
    cy: 0.7,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1.42,
    cy: 0.7,
    r: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 2.01,
    y: 1.46,
    width: 0.41,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 2.01,
    y: 1.87,
    width: 0.41,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 2.01,
    y: 2.27,
    width: 0.41,
    height: 0.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil6",
    points: "2.01,1.19 1.87,1.19 1.87,1.56 2.01,1.56 2.01,1.6 1.84,1.6 1.84,1.16 1.85,1.16 2.01,1.16 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil6",
    points: "2.01,1.98 1.88,1.98 1.88,2.36 2.01,2.36 2.01,2.39 1.85,2.39 1.85,1.95 1.87,1.95 2.01,1.95 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil7",
    cx: 1.79,
    cy: 0.7,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil8",
    cx: 2.2,
    cy: 1.13,
    r: 0.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "fil0 str1",
    points: "2.39,1.17 2.75,1.17 2.75,2.38 2.42,2.38 "
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M1.22 1.33c0.09,-0.01 0.17,0.06 0.18,0.14 0.01,0.1 -0.06,0.17 -0.14,0.18 -0.1,0.01 -0.17,-0.06 -0.18,-0.14 -0.01,-0.09 0.06,-0.17 0.14,-0.18zm0.49 0.04l0 0 -0.05 -0.13 -0.14 0.04 -0.07 -0.07 0.04 -0.14c-0.01,-0.01 -0.12,-0.05 -0.13,-0.06l-0.07 0.13c-0.07,0 -0.04,0 -0.1,0l-0.07 -0.13 -0.13 0.05 0.04 0.15c-0.02,0.01 -0.04,0.04 -0.06,0.05 0,0.01 -0.01,0.01 -0.01,0.02l-0.15 -0.04 -0.05 0.12 0.13 0.08c0,0.04 0,0.06 0,0.1l-0.13 0.07c0,0.02 0.04,0.1 0.05,0.13l0.14 -0.04c0.01,0 0.01,0.01 0.02,0.02 0,0 0.01,0.01 0.01,0.02 0.01,0 0.03,0.02 0.04,0.03l-0.04 0.14 0.13 0.06 0.07 -0.13c0.04,0 0.06,0 0.1,0l0.07 0.13 0.13 -0.05 -0.04 -0.14c0.02,-0.01 0.07,-0.06 0.08,-0.08l0.14 0.04c0,-0.02 0.05,-0.11 0.05,-0.12l-0.13 -0.07c0.01,-0.07 0.01,-0.04 0.01,-0.11l0.12 -0.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.59,
    y: 2.32,
    width: 1.05,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil9",
    x: 0.69,
    y: 2.47,
    width: 0.86,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.69,
    y: 2.78,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.92,
    y: 2.78,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 1.15,
    y: 2.78,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.69,
    y: 3,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.92,
    y: 3,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 1.15,
    y: 3,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.69,
    y: 3.23,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.92,
    y: 3.23,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 1.16,
    y: 3.21,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 1.15,
    y: 3.23,
    width: 0.16,
    height: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8",
    x: 1.4,
    y: 3,
    width: 0.14,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8",
    x: 1.41,
    y: 2.78,
    width: 0.14,
    height: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M0.65 0.74c0.06,0.01 0.09,0.06 0.08,0.11 -0.01,0.05 -0.06,0.08 -0.11,0.08 -0.06,-0.01 -0.09,-0.06 -0.08,-0.11 0.01,-0.06 0.06,-0.09 0.11,-0.08zm0.28 0.1l0 0 -0.01 -0.08 -0.09 0 -0.03 -0.06 0.05 -0.07c0,0 -0.06,-0.05 -0.06,-0.05l-0.07 0.06c-0.04,-0.01 -0.02,-0.01 -0.06,-0.02l-0.02 -0.08 -0.08 0 0 0.1c-0.01,0 -0.03,0.01 -0.04,0.02 0,0 -0.01,0 -0.01,0l-0.08 -0.04 -0.05 0.06 0.07 0.06c-0.01,0.03 -0.02,0.04 -0.02,0.06l-0.09 0.02c0,0.01 0.01,0.07 0.01,0.08l0.09 0c0,0.01 0,0.01 0,0.02 0.01,0 0.01,0.01 0.01,0.01 0,0.01 0.01,0.02 0.02,0.03l-0.05 0.07 0.06 0.05 0.07 -0.06c0.02,0.01 0.03,0.01 0.05,0.02l0.02 0.08 0.08 0 0.01 -0.09c0.01,0 0.05,-0.02 0.05,-0.03l0.08 0.05c0,-0.02 0.04,-0.06 0.05,-0.07l-0.06 -0.06c0.01,-0.04 0,-0.02 0.01,-0.06l0.09 -0.02z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0 str2",
    cx: 3.19,
    cy: 2.74,
    r: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8",
    transform: "matrix(-0.197311 -0.197311 -0.197311 0.197311 3.01347 2.96694)",
    width: 0.38,
    height: 2.05,
    rx: 0.19,
    ry: 0.19
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.f91907c9d4bcf42f9cfc11e3e3da14eb.svg";
export { ForwardRef as ReactComponent };